export default __webpack_public_path__ + "static/networking_b.0a7b842730969567c05359d92b774a84.png";